<template>
  <div class="add-contact">
    <el-button size="small" class="add-contat-btn" type="primary" @click="addContact()" v-if="item.isAdd">添加联系人</el-button>
    <div class="contact-box" v-if="contactArrayCopy.length">
      <div class="contact-item" v-for="(contact, index) in contactArrayCopy" :key="contact.key">
        <div class="contact-info">
          <span class="name">{{contact.name}}</span>
          <span class="phone">{{contact.phone}}</span>
        </div>
        <div class="contact-btn">
          <i class="el-icon-edit-outline" @click="addContact(index)" v-if="item.isEdit || contact.id === '0'"></i>
          <i class="el-icon-delete" @click="deleteContact(index)" v-if="item.isDel || contact.id === '0'"></i>
        </div>
      </div>
    </div>
    <div v-else-if="!item.isAdd">无</div>
  </div>
</template>

<script>
import { Message } from 'element-ui'
import { mapGetters, mapActions } from 'vuex'

export default {
  props: {
    item: {
      type: Object
    },
    child: {
      type: String
    }
  },

  data () {
    return {
    }
  },

  computed: {
    ...mapGetters([
      'contactArray'
    ]),

    contactArrayCopy () {
      return this.contactArray || []
    }
  },

  created () {
    if (this.item.attrValue && this.item.attrValue.length) {
      this.item.attrValue.forEach(item => {
        item.form = item.explains
        if (this.item.isEdit) {
          item.isEdit = true
        } else {
          item.isEdit = false
        }
        this.setContactArray({ 'contact': item })
      })
    }
    this.setExplains(this.item.explains)
  },

  methods: {
    ...mapActions([
      'setContactArray',
      'setExplains',
      'openAddNew',
      'setAttr'
    ]),
    addContact (index) {
      if (this.child === 'isPublic') {
        Message('公海客户不允许添加联系人！')
        return
      }
      let obj = {
        isOpenAddNew: true,
        index: index
      }
      this.openAddNew(obj)
    },
    deleteContact (index) {
      let obj = {
        contact: '',
        index: index
      }
      this.setAttr('addContact')
      this.setContactArray(obj)
    }
  },

  watch: {
  }
}
</script>

<style lang="less" scoped>
  .add-contact {
    .add-contat-btn {
      margin-bottom: 15px;
    }
    .contact-box {
      border-top: 1px solid #dcdfe6;
      .contact-item {
        height: 30px;
        padding: 0 5px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        border-bottom: 1px solid #dcdfe6;
        .contact-info {
          flex: 1;
          display: flex;
          align-items: center;
          .name {
            display: inline-block;
            width: 140px;
            margin-right: 10px;
            color: #666774;
            font-size: 12px;
            text-overflow: ellipsis;
            white-space: nowrap;
            overflow: hidden;
          }
          .phone {
            color: #dccccc;
            font-size: 11px;
          }
        }
        .contact-btn {
          margin-top: 5px;
          .el-icon-edit-outline {
            font-size: 20px;
            color: #409EFF;
            cursor: pointer;
            margin-right: 10px;
          }
          .el-icon-delete {
            font-size: 20px;
            color: #E51C23;
            cursor: pointer;
          }
        }
      }
    }
  }
</style>


// WEBPACK FOOTER //
// add-contact.vue?80d8e812